import React, { useState, useCallback, useEffect } from "react";
import { withRouter, Link } from "react-router-dom";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { Config } from "../../Config";
import SectionSeprator from "../SectionSeprator/SectionSeprator";
import Installment from "../../assets/images/Installment.svg";
import Guarantee from "../../assets/images/guarant.svg";
import Club from "../../assets/images/club.svg";
import StopWatch from "../../assets/images/stopWatch.svg";
import AddCart from "../../assets/images/addCart.svg";
import { toast } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ProductSlider.scss";

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "transparent",
        right: "10px",
        width: "30px",
        height: "30px",
        zIndex: "2",
      }}
      onClick={onClick}
    />
  );
};

const SamplePrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "block",
        background: "transparent",
        left: "10px",
        width: "30px",
        height: "30px",
        zIndex: "2",
      }}
      onClick={onClick}
    />
  );
};

const ProductSlider = (props) => {
  const [dragging, setDragging] = useState(false);
  const [skeletonCount, setSkeletonCount] = useState(0);
  const allProducts = useSelector((state) => state.products);
  useEffect(() => {
    let width = window.screen.width;
    if (width <= 1100) {
      if (width >= 992 && width <= 1100) {
        setSkeletonCount(3);
      } else if (width <= 992 && width >= 486) {
        setSkeletonCount(2);
      } else {
        setSkeletonCount(1);
      }
    } else {
      setSkeletonCount(4);
    }
  }, []);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const handleBeforeChange = useCallback(() => {
    setDragging(true);
  }, [setDragging]);

  const handleAfterChange = useCallback(() => {
    setDragging(false);
  }, [setDragging]);

  const settings = {
    dots: props.dots,
    infinite: props.infinite,
    // speed: 2000,
    slidesToShow: props.slideCount,
    slidesToScroll: props.sldeToScroll,
    autoplay: props.autoplay,
    autoplaySpeed: props.slideSpeed,
    pauseOnHover: true,
    swipeToSlide: props.swipeToSlide,
    variableWidth: false,
    adaptiveHeight: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      // {
      //   breakpoint: 576,
      //   settings: {
      //     slidesToShow: 1,
      //     slidesToScroll: 1,
      //   },
      // },
    ],
  };
  return (
    <section className="productSlider">
      {props.sliderData.length > 0 ? (
        <div className="desktop">
          <SectionSeprator title={props.title} />
          <div className="productContents">
            <Slider {...settings} beforeChange={handleBeforeChange} afterChange={handleAfterChange}>
              {props.sliderData?.length > 0 &&
                props.sliderData?.map((item, index) => {
                  return (
                    <div className="wrapperHelper" key={index}>
                      <a
                        href={`/products/${item.id}/${item.productName.replaceAll(" ", "-")}`}
                        className="productItems"
                        draggable="false"
                      >
                        <div className="itemGroups">
                          {item.isInstallments && (
                            <div className="itemGroupFigure">
                              <img src={Installment} alt="Installment" className="figureImage" />
                            </div>
                          )}
                          {item.hasGuarantee && (
                            <div className="itemGroupFigure">
                              <img src={Guarantee} alt="Guarantee" className="figureImage" />
                            </div>
                          )}
                          {item.point > 0 && (
                            <div className="itemGroupFigure">
                              <img src={Club} alt="Club" className="figureImage" />
                            </div>
                          )}
                        </div>
                        <span className="imageFigure">
                          <img src={item.image} alt={item.title} />
                        </span>
                        <div className="productInfo">
                          <span className="title">{item.productName}</span>
                          <div className="priceBox">
                            <div className="item2">
                              <div className="exist">
                                {item.count > 0 ? (
                                  <>
                                    <span className="green"></span> موجود
                                  </>
                                ) : (
                                  <>
                                    <span className="red"></span> ناموجود
                                  </>
                                )}
                              </div>
                              <p className="amount">{Config.separate(item.price)} ریال </p>
                            </div>
                          </div>
                        </div>
                        <div className="addCart">
                          <img src={AddCart} alt="add to cart" />
                          <span>افزودن به سبد خرید</span>
                        </div>
                      </a>
                    </div>
                  );
                })}
            </Slider>
          </div>
        </div>
      ) : (
        <>
          <SectionSeprator title={props.title} />
          <Skeleton
            highlightColor={Config.skeletonHighlightColor}
            containerClassName="productsSkeletonWrapper"
            className="productsSkeletonItem skeleton"
            count={skeletonCount}
          />
        </>
      )}
    </section>
  );
};

export default React.memo(withRouter(ProductSlider));
